import { Back } from '../../../components/buttons/backButton/Back'
import MainButton from "../../../components/buttons/mainButton/MainButton"
import Field from "../../../components/textField/Field"
import { translations } from "../../../configs/translations"
import { useStore } from "../../../store/store"

interface PasswordRecoveryWindowCodeProps {
    code: number;
    errors: any;
    registerField: any;
    onSubmit: () => void;
    onEmailSubmit: () => void;
    time: number;
    onBack: () => void;
}

export const PasswordRecoveryWindowCode = ({
    code,
    errors,
    registerField,
    onSubmit,
    onEmailSubmit,
    time,
    onBack
}: PasswordRecoveryWindowCodeProps) => {
    const language = useStore(state => state.language);
    const t = translations[language];

    return (
        <div className="container">
            <div className="window window-recovery">
                <div className="window-recovery-back-button">
                    <Back onClick={() => onBack()} text={""} />
                </div>
                <h1 className='title'>{t.password_recovery} 2/3</h1>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit();
                }} className='fields'>
                    <Field 
                        value={code}
                        label={t.code} 
                        placeholder={t.enter_code}
                        error={errors.code?.message}
                        type="number"
                        {...registerField('code')}
                    />

                    <MainButton text={t.continue} type="submit" />
                </form>

                <div className="links">
                    <button
                        type="button"
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            font: 'inherit',
                            color: `${time > 0 ? 'lightgray' : '#F0CB2D'}`,
                            cursor: `${time > 0 ? 'not-allowed' : 'pointer'}`
                        }}
                        onClick={() => {
                            if (time <= 0) {
                                onEmailSubmit();
                            }
                        }}
                    >{`${t.send_again} ${time > 0 ? `(${Math.floor(time / 60).toString().padStart(2, '0')}:${(time % 60).toString().padStart(2, '0')})` : ''}`}</button>
                </div>
            </div>
        </div>
    );
}